import { render, staticRenderFns } from "./qcWorkbench.vue?vue&type=template&id=17b4ea9a&scoped=true&"
import script from "./qcWorkbench.vue?vue&type=script&lang=js&"
export * from "./qcWorkbench.vue?vue&type=script&lang=js&"
import style0 from "./qcWorkbench.vue?vue&type=style&index=0&id=17b4ea9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b4ea9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\english\\new-evaluation\\src\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17b4ea9a')) {
      api.createRecord('17b4ea9a', component.options)
    } else {
      api.reload('17b4ea9a', component.options)
    }
    module.hot.accept("./qcWorkbench.vue?vue&type=template&id=17b4ea9a&scoped=true&", function () {
      api.rerender('17b4ea9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/questionBank/qcWorkbench.vue"
export default component.exports